import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';

const TextDriftScaleListItem = (props) => {
    const { scale, index, updateTextElement } = props;

    const onScaleChange = (value) => updateTextElement(index, { drift: { scale: value } });

    return (
        <SliderListItem
            title='Size'
            displayMultiplier={50}
            value={scale}
            min={0}
            max={100}
            step={1}
            onValueChange={onScaleChange}
            toolTip='How much the text size increases during loud audio.'
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const { scale } = state.createPreview.present.videoSettings.text.textElements[ownProps.index].drift;
    return { scale };
};

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextDriftScaleListItem);
